import {
  APP_INITIALIZER,
  Provider,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { resolveHealthIconAssetPath } from '@app/shared/common/health-icons';

/**
 * Creates an IconResolver function for Angular Material's MatIconRegistry.
 * Matches namespaces "health" and "healthicons".
 */
export function createHealthIconResolver(sanitizer: DomSanitizer) {
  return (name: string, namespace: string) => {
    if (namespace !== 'health' && namespace !== 'healthicons') {
      return null;
    }

    const assetPath = resolveHealthIconAssetPath(name);
    return sanitizer.bypassSecurityTrustResourceUrl(assetPath);
  };
}

/**
 * Registers the health icons resolver with MatIconRegistry during application startup.
 */
export function initializeHealthIcons(
  iconRegistry: MatIconRegistry,
  sanitizer: DomSanitizer
): () => void {
  return () => {
    iconRegistry.addSvgIconResolver(createHealthIconResolver(sanitizer));
  };
}

/**
 * Provider function to be added to application bootstrap providers array.
 */
export function provideHealthIcons(): Provider {
  return {
    provide: APP_INITIALIZER,
    useFactory: initializeHealthIcons,
    deps: [MatIconRegistry, DomSanitizer],
    multi: true,
  };
}
